import { get } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants'
import IMAGE_CONSTANTS from '@/js/helper/image-constants.js'

export const getMediaByType = ({
  media,
  type = API_CONSTANTS.AIMEOS.MEDIA.TYPE.DEFAULT,
  mimeTypeRegex,
}) =>
  media.filter(
    mediaItem =>
      get(mediaItem, API_CONSTANTS.AIMEOS.MEDIA.PATHS.TYPE) === type &&
      (mimeTypeRegex
        ? mimeTypeRegex.test(get(mediaItem, API_CONSTANTS.AIMEOS.MEDIA.PATHS.MIMETYPE))
        : true),
  )

export const getMediaPreview = ({ mediaItem = {}, size = 1 } = {}) => {
  const previews = Object.entries(get(mediaItem, API_CONSTANTS.AIMEOS.MEDIA.PATHS.PREVIEWS, {}))
    .map(([key, value]) => ({ size: key, url: value }))
    .sort((a, b) => {
      return a.size - b.size
    })
  const selectedPreview = previews.find(preview => preview.size >= size)
  return (
    selectedPreview || {
      url: get(mediaItem, API_CONSTANTS.AIMEOS.MEDIA.PATHS.PREVIEW),
      size: undefined,
    }
  )
}

export const getPreviewImages = ({
  images,
  imageMinSize = IMAGE_CONSTANTS.IMAGE_MIN_SIZE.DEFAULT,
}) => images.map(image => getMediaPreview({ mediaItem: image, size: imageMinSize }))

export const getPreviewImage = ({ image, imageMinSize = IMAGE_CONSTANTS.IMAGE_MIN_SIZE.DEFAULT }) =>
  getMediaPreview({ mediaItem: image, size: imageMinSize })

export const getImageSize = ({ image }) => {
  return get(image, 'size')
}

export const getImageUrls = ({ images, contentBaseurl }) =>
  images.map(image => (image ? `${contentBaseurl}/${get(image, 'url')}` : undefined))

export const getImageUrl = ({ image, contentBaseurl }) =>
  image ? `${contentBaseurl}/${get(image, 'url')}` : undefined

export const getCompareMediaPreview = ({ mediaPreviews = {}, size = 1 } = {}) => {
  const previews = Object.entries(mediaPreviews)
    .map(([key, value]) => ({ size: key, url: value }))
    .sort((a, b) => {
      return a.size - b.size
    })
  const selectedPreview = previews.find(preview => preview.size >= size)
  return (
    selectedPreview || {
      url: get(mediaPreviews, IMAGE_CONSTANTS.IMAGE_MIN_SIZE.PRODUCT_LIST),
      size: undefined,
    }
  )
}
